import Vue from 'vue'
import Router from 'vue-router'
import Survey from '../components/Survey.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:slug/:jwt',
      name: 'Survey',
      component: Survey
    },
    {
      path: '/:slug',
      name: 'Survey',
      component: Survey
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js